export default {
	Danish: 'dk',
	English: 'en',
	Estonian: 'et',
	Greek: 'el',
	Italian: 'it'
}
  